export function getRandomId(): number {
  return Math.floor(Math.random() * 99995) + 10000;
}
